import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import RoomView from '@/views/RoomView.vue';
import HomeView from '@/views/HomeView.vue';
import AdminView from '@/views/AdminView.vue';
import CampaignView from '@/views/admin-views/CampaignView.vue';
import LogView from '@/views/admin-views/LogView.vue';
import ProviderView from '@/views/admin-views/ProviderView.vue';
import QuestionnaireView from '@/views/admin-views/QuestionnaireView.vue';
import SiteinfoView from '@/views/admin-views/SiteinfoView.vue';
import UserView from '@/views/admin-views/UserView.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView,
  },
  {
    path: '/chat',
    name: 'RoomView',
    component: RoomView,
  },
  {
    path: '/room/:spaceid/:roomid',
    name: 'RoomViewWithId',
    component: RoomView,
  },
  {
    path: '/admin',
    name: 'AdminView',
    component: AdminView,
    children: [
      {
        path: 'campaign',
        name: 'campaign',
        component: CampaignView,
      },
      {
        path: 'log',
        name: 'log',
        component: LogView,
      },
      {
        path: 'provider',
        name: 'provider',
        component: ProviderView,
      },
      {
        path: 'questionnaire',
        name: 'questionnaire',
        component: QuestionnaireView,
      },
      {
        path: 'siteinfo',
        name: 'siteinfo',
        component: SiteinfoView,
      },
      {
        path: 'user',
        name: 'user',
        component: UserView,
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
